import { AuthProvider } from 'contexts/AuthContext';
import { GridProvider } from 'contexts/GridContext';
import { DropsProvider } from 'contexts/DropsContext';
import { DocumentosProvider } from 'contexts/DocumentosContext';
import { DashboardProvider } from 'contexts/DashboardContext';
import {
  DialogProvider,
  ModalProvider,
  DrawerProvider,
} from 'components/Modals';

const Providers = ({ children }) => (
  <AuthProvider>
    <GridProvider>
      <DropsProvider>
        <DocumentosProvider>
          <DashboardProvider>
            <ModalProvider>
              <DialogProvider>
                <DrawerProvider>{children}</DrawerProvider>
              </DialogProvider>
            </ModalProvider>
          </DashboardProvider>
        </DocumentosProvider>
      </DropsProvider>
    </GridProvider>
  </AuthProvider>
);

export default Providers;
